import { router } from "@inertiajs/react"
import { LoaderCircle, PlayCircle } from "lucide-react"
import { useState } from "react"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface DemoAccessButtonProps {
  className?: string
  label?: string
  variant?: "default" | "outline" | "secondary" | "ghost" | "link"
}

export function DemoAccessButton({
  className,
  label = "Try the demo",
  variant = "outline",
}: DemoAccessButtonProps) {
  const [processing, setProcessing] = useState(false)

  const handleClick = () => {
    router.post(
      "/demo_session",
      {},
      {
        onStart: () => setProcessing(true),
        onFinish: () => setProcessing(false),
      },
    )
  }

  return (
    <Button
      type="button"
      variant={variant}
      className={cn("w-full cursor-pointer", className)}
      disabled={processing}
      onClick={handleClick}
    >
      {processing ? (
        <LoaderCircle className="h-4 w-4 animate-spin" />
      ) : (
        <PlayCircle className="h-4 w-4" />
      )}
      {label}
    </Button>
  )
}
